//Action Type
export const AddressDetails_ActionTypes = {
    FETCH_AddressDetails_REQUEST : 'FETCH_AddressDetails_REQUEST',
    FETCH_AddressDetails_SUCCESS : 'FETCH_AddressDetails_SUCCESS',
    FETCH_AddressDetails_FAILURE : 'FETCH_AddressDetails_FAILURE',
    CLEAR_AddressDetails : 'CLEAR_AddressDetails'
}

//Action
export const fetchAddressDetailsRequest = (fetch_type)=>{  //fetch_type can be -Suggestion_Select , Text_Search , Map_Click
    return {
        type : AddressDetails_ActionTypes.FETCH_AddressDetails_REQUEST,
        payload : fetch_type
    }
}

export const fetchAdressDetailsSuccess = (data)=>{
    return {
        type : AddressDetails_ActionTypes.FETCH_AddressDetails_SUCCESS,
        payload : data
    }
}

export const fetchAddressDetailsFailure = (error)=>{
    return {
        type :AddressDetails_ActionTypes.FETCH_AddressDetails_FAILURE,
        paylod : error
    }
}

export const clearAddressDetails = ()=>{
    return {
        type :AddressDetails_ActionTypes.CLEAR_AddressDetails
    }
}

const initialState = {
    data : [],
    loading : false,
    error : '',
    fetchType : '' // //fetch_type can be -Suggestion_Select , Text_Search , Map_Click
}

//Reducer
export const addressDetailsReducer = (state = initialState , {type, payload})=>{
    switch (type) {
      case AddressDetails_ActionTypes.FETCH_AddressDetails_REQUEST:
        return {
            ...state,
            data : [],
            loading : true,
            error : ''
        }

      case AddressDetails_ActionTypes.FETCH_AddressDetails_SUCCESS:
          return {
              ...state,
              data : payload,
              loading : false,
              error : ''
          }

      case AddressDetails_ActionTypes.FETCH_AddressDetails_FAILURE:
          return {
              ...state,
              data : [],
              loading : false,
              error : payload
          }

      case AddressDetails_ActionTypes.CLEAR_AddressDetails:
          return {
              ...state,
              data : [],
              loading : false,
              error : '',
          }

      default:
        return state;
    }
      
}
